





































/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import { INameAndDescription } from '@/api/types/response.types'

export default Vue.extend({
  name: 'MailboxSettingsEmailSignature',

  metaInfo(): any {
    return {
      title: `Email Signature - ${this.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      ColorAssistant,
      isLoading: true,
      isSubmitting: false,
      name: '',
      signatureVars: [] as INameAndDescription[],
      signature: '',
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },

  async created() {
    this.isLoading = true
    await this.getEmailSignatureInfo()
    this.isLoading = false
  },

  methods: {
    async getEmailSignatureInfo() {
      try {
        const response = await MailboxesAPI.get_OutgoingSignatureTemplate(
          this.id,
        )
        this.name = response.name
        this.signatureVars = response.listSignatureVars
        this.signature = response.signature
      } catch (error) {
        this.$error.emit(error)
      }
    },

    async save() {
      try {
        this.isSubmitting = true
        const response = await MailboxesAPI.post_OutgoingSignatureTemplate(
          this.id,
          this.signature,
        )
        this.$messaging.showSuccess(response.message)
        // Fetch again for any server HTML cleanup updates
        await this.getEmailSignatureInfo()
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.isSubmitting = false
      }
    },
  },
})
